var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "d-flex", class: _vm.getClasses(), attrs: { id: "asset" } },
    [
      [0].includes(_vm.asset.broadcasting)
        ? _c("PreLive")
        : [1].includes(_vm.asset.broadcasting)
        ? _c("Live")
        : [2, 3].includes(_vm.asset.broadcasting) &&
          (_vm.asset.type === 5 || ![3, 5].includes(_vm.asset.status_id))
        ? _c("PostLive")
        : _c("OnDemand"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }